import React from "react";
import { SetPasswordContextProvider } from "./SetPasswordView";
import SetPasswordPage from "./views/SetPasswordPage";

const SetPassword = () => {
  return (
    <SetPasswordContextProvider>
      <SetPasswordPage />
    </SetPasswordContextProvider>
  );
};

export default SetPassword;
